<div (click)="navigateToDetails()"
     class="resource-card-wrapper">
  <div class="image-wrapper">
    <app-image [url]="(resource?.imgUrl || resource?.imageUrl) | cdnBaseUrl"
               alt=""></app-image>
  </div>
  <div class="card-body">
    <div class="title-section">
      <p class="title-content">
        {{resource?.title}}
      </p>
    </div>
    <div class="description-section">
      <p class="description-content">
        {{resource?.description}}
      </p>
    </div>
    <div class="date-status-section">
      <div *ngIf="loggedInUserRole === allRoles.superAdmin"
           class="status-badge">
        {{resource?.statusName}}
      </div>
    </div>
  </div>
</div>
